import React from "react";
import OrderList from "../../../Common/Components/OrlderList/General";

const GeneralOrders = () => {
    return <OrderList />;
};

export default GeneralOrders;
